import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthCard } from "@/components/auth/AuthCard";
import { api, apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (pwd !== confirm) return setError("Le due password non coincidono");
    setBusy(true);
    try {
      await api.resetPassword(token, pwd);
      toast.success("Password aggiornata, ora puoi accedere");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(apiError(err, "Aggiornamento non riuscito"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard testId="reset-password-card" title="Nuova password" subtitle="Scegli la password per il tuo account">
      {!token ? (
        <p data-testid="reset-missing-token" className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">Collegamento non valido. Richiedine uno nuovo.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs font-medium text-slate-600">Nuova password (min. 8 caratteri)</Label>
            <Input data-testid="reset-password-input" type="password" autoComplete="new-password" required value={pwd} onChange={(e) => setPwd(e.target.value)} className="h-11 rounded-xl" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-medium text-slate-600">Ripeti la password</Label>
            <Input data-testid="reset-confirm-input" type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-11 rounded-xl" />
          </div>
          {error && <p data-testid="reset-error" className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
          <Button type="submit" data-testid="reset-submit-btn" disabled={busy} className="h-11 w-full gap-2 rounded-xl bg-emerald-600 hover:bg-emerald-700">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Salva nuova password
          </Button>
        </form>
      )}
      <Link to="/forgot-password" data-testid="reset-new-link" className="block text-center text-sm font-medium text-slate-600 hover:text-slate-900">Richiedi un nuovo collegamento</Link>
    </AuthCard>
  );
}
